"use client";

import Analytics from "@/components/common/Analytics";
import Styles from "@/components/common/Styles";
import { Auth0Provider } from "@auth0/auth0-react";
import { AuthContextProvider } from "@/contexts/common/AuthContextProvider";
import { AlertProvider } from "@/contexts/common/AlertProvider";
import { EnvironmentNotificationBar } from "@/components/common/EnvironmentBranding";
import { Env } from "@/utils/common/env";
import { useState, useEffect } from "react";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isBarVisible, setIsBarVisible] = useState<boolean>(true);

  useEffect(() => {
    // Check if the bar was previously closed in this session
    const isBarClosed = sessionStorage.getItem('environmentBarClosed') === 'true';
    setIsBarVisible(!isBarClosed && !Env.IsProduction());
  }, []);
  return (
    <html lang="en">
      <head>
        <link rel="icon" href="/favicon.png" />
        <script
          src="https://kit.fontawesome.com/f8dd293366.js"
          crossOrigin="anonymous"
          async
        ></script>
      </head>
      <body>
        <Analytics />
        <Styles />
        <Auth0Provider
          domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN!}
          clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID!}
          useRefreshTokens
          cacheLocation="localstorage"
          cookieDomain={process.env.NEXT_PUBLIC_AUTH0_COOKIE_DOMAIN!}
        >
          <AuthContextProvider>
            <AlertProvider>
              <EnvironmentNotificationBar onVisibilityChange={setIsBarVisible} />
              <div className={isBarVisible ? 'pt-10' : ''}>
                {children}
              </div>
            </AlertProvider>
          </AuthContextProvider>
        </Auth0Provider>
      </body>
    </html>
  );
}
